// extracted by mini-css-extract-plugin
export default {"container":"BlogItemPage_container__ON14k","header":"BlogItemPage_header__i3RtA","text_body":"BlogItemPage_text_body__e6Y7U"};